class CollisionDetectionServiceClass {
  getCollisions(sourceBoundingBox, targetBoundingBox, includeFullyOutside = false) {
    const collisions = {};

    collisions.bottom = sourceBoundingBox.bottom > targetBoundingBox.bottom && sourceBoundingBox.top < targetBoundingBox.bottom;
    collisions.left = sourceBoundingBox.left < targetBoundingBox.left && sourceBoundingBox.right > targetBoundingBox.left;
    collisions.right = sourceBoundingBox.right > targetBoundingBox.right && sourceBoundingBox.left < targetBoundingBox.right;
    collisions.top = sourceBoundingBox.top < targetBoundingBox.top && sourceBoundingBox.bottom > targetBoundingBox.top;

    if (includeFullyOutside) {
      collisions.bottom = collisions.bottom || sourceBoundingBox.top > targetBoundingBox.bottom;
      collisions.left = collisions.left || sourceBoundingBox.right < targetBoundingBox.left;
      collisions.right = collisions.right || sourceBoundingBox.left > targetBoundingBox.right;
      collisions.top = collisions.top || sourceBoundingBox.bottom < targetBoundingBox.top;
    }

    const ultimateCollisions = {};

    // Failsafe to ensure we never render above 0
    ultimateCollisions.top = sourceBoundingBox.top < targetBoundingBox.top;

    // Failsafe to ensure we never render left of 0
    ultimateCollisions.left = sourceBoundingBox.left < targetBoundingBox.left;

    ultimateCollisions.left = ultimateCollisions.left || (collisions.left && !collisions.right);
    ultimateCollisions.right = !ultimateCollisions.left && collisions.right;
    ultimateCollisions.top = ultimateCollisions.top || (collisions.top && !collisions.bottom);
    ultimateCollisions.bottom = !ultimateCollisions.top && collisions.bottom;

    // Only return the true keys
    return Object.keys(ultimateCollisions).reduce((acc, key) => {
      if (ultimateCollisions[key]) {
        return {
          ...acc,
          [key]: true,
        };
      }

      return acc;
    }, {});
  }

  // Is sourceBoundingBox fully inside the boundaries of targetBoundingBox?
  isFullyContained(sourceBoundingBox, targetBoundingBox) {
    return (
      sourceBoundingBox.left >= targetBoundingBox.left &&
      sourceBoundingBox.right <= targetBoundingBox.right &&
      sourceBoundingBox.top >= targetBoundingBox.top &&
      sourceBoundingBox.bottom <= targetBoundingBox.bottom
    );
  }

  isFullyOutside(sourceBoundingBox, targetBoundingBox) {
    return (
      sourceBoundingBox.right < targetBoundingBox.left ||
      targetBoundingBox.right < sourceBoundingBox.left ||
      sourceBoundingBox.bottom < targetBoundingBox.top ||
      targetBoundingBox.bottom < sourceBoundingBox.top
    );
  }

  // Is there any overlap between the boundaries sourceBoundingBox and targetBoundingBox?
  hasCollision(sourceBoundingBox, targetBoundingBox) {
    return (
      sourceBoundingBox.left <= targetBoundingBox.right &&
      sourceBoundingBox.right >= targetBoundingBox.left &&
      sourceBoundingBox.top <= targetBoundingBox.bottom &&
      sourceBoundingBox.bottom >= targetBoundingBox.top
    );
  }
}

export const CollisionDetectionService = new CollisionDetectionServiceClass();
